"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _logger = require("@insided/shared/services/logger");

var _IntegrationSetup = _interopRequireDefault(require("./IntegrationSetup"));

var _axios = _interopRequireDefault(require("axios"));

var _PanelItems = require("./components/PanelItems");

var _UninstallModal = _interopRequireDefault(require("./components/UninstallModal"));

var _Tabs = require("./components/skilljar/Tabs");

var _publish = _interopRequireDefault(require("../../components/tracker/publish"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _interfaces = require("@insided/deprecated-control/integrations/interfaces");

var _constants = require("@insided/shared/constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SkilljarIntegration = /*#__PURE__*/function (_Integration) {
  (0, _inherits2.default)(SkilljarIntegration, _Integration);

  var _super = _createSuper(SkilljarIntegration);

  function SkilljarIntegration(props) {
    var _props$enabledFederat, _props$apiToken, _props$subdomain, _props$enabledFederat2, _props$apiToken2, _props$subdomain2;

    var _this;

    (0, _classCallCheck2.default)(this, SkilljarIntegration);
    _this = _super.call(this, props);
    _this.state = {
      isInstalled: !!(props.apiToken && props.subdomain),
      isFederatedSearchActive: (_props$enabledFederat = props.enabledFederatedSearch) !== null && _props$enabledFederat !== void 0 ? _props$enabledFederat : false,
      apiKey: (_props$apiToken = props.apiToken) !== null && _props$apiToken !== void 0 ? _props$apiToken : '',
      subdomain: (_props$subdomain = props.subdomain) !== null && _props$subdomain !== void 0 ? _props$subdomain : '',
      showFederatedSearchActionButtons: false,
      federatedSearchInitialSyncCompleted: false,
      storedState: {
        isFederatedSearchActive: (_props$enabledFederat2 = props.enabledFederatedSearch) !== null && _props$enabledFederat2 !== void 0 ? _props$enabledFederat2 : false,
        apiKey: (_props$apiToken2 = props.apiToken) !== null && _props$apiToken2 !== void 0 ? _props$apiToken2 : '',
        subdomain: (_props$subdomain2 = props.subdomain) !== null && _props$subdomain2 !== void 0 ? _props$subdomain2 : ''
      },
      activeTab: 0,
      showUnsavedChangesModal: false,
      showUninstallModal: false
    };
    _this.resetFederatedSearchSetting = _this.resetFederatedSearchSetting.bind((0, _assertThisInitialized2.default)(_this));
    _this.saveFederatedSearchSetting = _this.saveFederatedSearchSetting.bind((0, _assertThisInitialized2.default)(_this));
    _this.onInstall = _this.onInstall.bind((0, _assertThisInitialized2.default)(_this));
    _this.onUninstall = _this.onUninstall.bind((0, _assertThisInitialized2.default)(_this));
    _this.onResetInstallationTab = _this.onResetInstallationTab.bind((0, _assertThisInitialized2.default)(_this));
    _this.onResetIntegrationTab = _this.onResetIntegrationTab.bind((0, _assertThisInitialized2.default)(_this));
    _this.resetIntegrationPanelChanges = _this.resetIntegrationPanelChanges.bind((0, _assertThisInitialized2.default)(_this));
    _this.dismissMessage = _this.dismissMessage.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(SkilljarIntegration, [{
    key: "checkPanelHasUnsavedChanges",
    value: function checkPanelHasUnsavedChanges() {
      var _this$state = this.state,
          apiKey = _this$state.apiKey,
          subdomain = _this$state.subdomain,
          isFederatedSearchActive = _this$state.isFederatedSearchActive,
          storedState = _this$state.storedState;
      var hasApiTokenChanged = apiKey !== storedState.apiKey;
      var hasSubdomainChanged = subdomain !== storedState.subdomain;
      var hasFederatedSearchSettingChanged = isFederatedSearchActive !== storedState.isFederatedSearchActive;
      return hasApiTokenChanged || hasSubdomainChanged || hasFederatedSearchSettingChanged;
    }
  }, {
    key: "onInstall",
    value: function () {
      var _onInstall = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var successMessage, errorMessage, _this$state2, apiKey, subdomain, validatedFields, data, result, _result$data, apiToken, _subdomain, updatedStoredState, _this$state$storedSta, _apiKey, _subdomain2;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setState({
                  messageType: undefined,
                  errorFields: [],
                  isSavingCredentials: true
                });
                successMessage = 'All set! Skilljar installed.';
                errorMessage = 'Sorry, something went wrong, please try again.';
                _this$state2 = this.state, apiKey = _this$state2.apiKey, subdomain = _this$state2.subdomain;
                validatedFields = [];

                if (apiKey === '') {
                  validatedFields.push({
                    field: 'apiKey',
                    message: 'Please enter an API key.'
                  });
                }

                if (subdomain === '') {
                  validatedFields.push({
                    field: 'subdomain',
                    message: 'Please enter a subdomain.'
                  });
                }

                if (!(validatedFields.length !== 0)) {
                  _context.next = 10;
                  break;
                }

                this.setState({
                  errorFields: validatedFields,
                  isSavingCredentials: false
                });
                return _context.abrupt("return");

              case 10:
                data = {
                  apiToken: apiKey,
                  subdomain: subdomain
                };
                _context.prev = 11;
                _context.next = 14;
                return _axios.default.post('/integration/skilljar/settings', data);

              case 14:
                result = _context.sent;
                _result$data = result.data, apiToken = _result$data.apiToken, _subdomain = _result$data.subdomain;
                updatedStoredState = _objectSpread({}, this.state.storedState);
                updatedStoredState.apiKey = apiToken;
                updatedStoredState.subdomain = _subdomain;
                this.setState({
                  isInstalled: !!(apiToken && _subdomain),
                  apiKey: apiToken,
                  subdomain: _subdomain,
                  storedState: updatedStoredState,
                  message: successMessage,
                  messageType: 'success',
                  errorFields: [],
                  isSavingCredentials: false
                });

                _publish.default.trackEvent('userevent', {
                  type: 'Skilljar app installed'
                });

                _context.next = 28;
                break;

              case 23:
                _context.prev = 23;
                _context.t0 = _context["catch"](11);

                _logger.logger.error(_context.t0, {
                  component: 'SkilljarIntegrationV2',
                  action: 'install'
                });

                _this$state$storedSta = this.state.storedState, _apiKey = _this$state$storedSta.apiKey, _subdomain2 = _this$state$storedSta.subdomain;
                this.setState({
                  message: errorMessage,
                  messageType: 'error',
                  apiKey: _apiKey,
                  subdomain: _subdomain2,
                  isInstalled: false,
                  errorFields: [],
                  isSavingCredentials: false
                });

              case 28:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[11, 23]]);
      }));

      function onInstall() {
        return _onInstall.apply(this, arguments);
      }

      return onInstall;
    }()
  }, {
    key: "onResetIntegrationTab",
    value: function onResetIntegrationTab(activeTab) {
      this.resetFederatedSearchSetting();
      this.setState({
        activeTab: activeTab
      });
    }
  }, {
    key: "onResetInstallationTab",
    value: function onResetInstallationTab(activeTab) {
      this.setState({
        apiKey: '',
        subdomain: '',
        showUnsavedChangesModal: false,
        errorFields: [],
        activeTab: activeTab
      });
    }
  }, {
    key: "onUninstall",
    value: function () {
      var _onUninstall = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var successMessage, errorMessage, updatedStoredState;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.setState({
                  messageType: undefined
                });
                successMessage = "You've uninstalled Skilljar.";
                errorMessage = 'Sorry, something went wrong, please try again.';
                _context2.prev = 3;
                _context2.next = 6;
                return _axios.default.delete('/integration/skilljar/settings');

              case 6:
                updatedStoredState = _objectSpread({}, this.state.storedState);
                updatedStoredState.isFederatedSearchActive = false;
                updatedStoredState.apiKey = '';
                updatedStoredState.subdomain = '';
                this.setState({
                  isInstalled: false,
                  apiKey: '',
                  subdomain: '',
                  isFederatedSearchActive: false,
                  storedState: updatedStoredState,
                  showUninstallModal: false,
                  messageType: 'success',
                  message: successMessage
                });
                _context2.next = 17;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](3);

                _logger.logger.error(_context2.t0, {
                  component: 'SkilljarIntegrationV2',
                  action: 'uninstall'
                });

                this.setState({
                  messageType: 'error',
                  message: errorMessage,
                  showUninstallModal: false
                });

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 13]]);
      }));

      function onUninstall() {
        return _onUninstall.apply(this, arguments);
      }

      return onUninstall;
    }()
  }, {
    key: "resetIntegrationPanelChanges",
    value: function resetIntegrationPanelChanges(activeTab) {
      this.setState({
        activePanel: undefined
      });
      var _this$state3 = this.state,
          isFederatedSearchActive = _this$state3.isFederatedSearchActive,
          storedState = _this$state3.storedState;

      if (isFederatedSearchActive !== storedState.isFederatedSearchActive) {
        this.resetFederatedSearchSetting();
      }

      if (this.state.selectedTab !== undefined && this.state.selectedTab !== this.state.activeTab) {
        this.setState({
          activeTab: activeTab
        });
      }
    }
  }, {
    key: "resetFederatedSearchSetting",
    value: function resetFederatedSearchSetting() {
      var _this$state4 = this.state,
          storedState = _this$state4.storedState,
          selectedPanel = _this$state4.selectedPanel;
      this.setState({
        isFederatedSearchActive: storedState.isFederatedSearchActive,
        showFederatedSearchActionButtons: false,
        showUnsavedChangesModal: false,
        activePanel: selectedPanel
      });
    }
  }, {
    key: "saveFederatedSearchSetting",
    value: function () {
      var _saveFederatedSearchSetting = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var errorMessage, isFederatedSearchActive, response, successMessage, updatedState, _isFederatedSearchActive;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.setState({
                  messageType: undefined,
                  isSavingFederatedSearchSetting: true
                });
                errorMessage = "Something went wrong, setting can't be updated. Please try again.";
                isFederatedSearchActive = this.state.isFederatedSearchActive;
                _context3.prev = 3;
                _context3.next = 6;
                return _axios.default.post('/integration/skilljar/toggleFederatedSearch', {
                  isActive: isFederatedSearchActive
                });

              case 6:
                response = _context3.sent;
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                successMessage = isFederatedSearchActive ? "Federated search is enabled on your community. ".concat(response.data.count, " Skilljar courses are successfully synchronized!") : 'Changes are saved successfully.';
                updatedState = _objectSpread({}, this.state.storedState);
                updatedState.isFederatedSearchActive = isFederatedSearchActive;
                this.setState({
                  storedState: updatedState,
                  message: successMessage,
                  messageType: 'success',
                  showFederatedSearchActionButtons: false,
                  isSavingFederatedSearchSetting: false,
                  federatedSearchInitialSyncCompleted: true
                });

                _publish.default.trackEvent('userevent', {
                  type: "Skilljar federated search ".concat(isFederatedSearchActive ? 'enabled' : 'disabled')
                });

                _context3.next = 18;
                break;

              case 14:
                _context3.prev = 14;
                _context3.t0 = _context3["catch"](3);
                _isFederatedSearchActive = this.state.storedState.isFederatedSearchActive;
                this.setState({
                  messageType: 'error',
                  message: errorMessage,
                  showFederatedSearchActionButtons: false,
                  isSavingFederatedSearchSetting: false,
                  isFederatedSearchActive: _isFederatedSearchActive,
                  federatedSearchInitialSyncCompleted: false
                });

              case 18:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 14]]);
      }));

      function saveFederatedSearchSetting() {
        return _saveFederatedSearchSetting.apply(this, arguments);
      }

      return saveFederatedSearchSetting;
    }()
  }, {
    key: "dismissMessage",
    value: function dismissMessage() {
      this.setState({
        messageType: undefined,
        message: ''
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state5 = this.state,
          isInstalled = _this$state5.isInstalled,
          messageType = _this$state5.messageType,
          message = _this$state5.message,
          activeTab = _this$state5.activeTab,
          showUninstallModal = _this$state5.showUninstallModal,
          apiKey = _this$state5.apiKey,
          subdomain = _this$state5.subdomain,
          errorFields = _this$state5.errorFields,
          showUnsavedChangesModal = _this$state5.showUnsavedChangesModal,
          isSavingCredentials = _this$state5.isSavingCredentials,
          isFederatedSearchActive = _this$state5.isFederatedSearchActive,
          showFederatedSearchActionButtons = _this$state5.showFederatedSearchActionButtons,
          isSavingFederatedSearchSetting = _this$state5.isSavingFederatedSearchSetting,
          storedState = _this$state5.storedState,
          activePanel = _this$state5.activePanel,
          federatedSearchInitialSyncCompleted = _this$state5.federatedSearchInitialSyncCompleted;
      var panelHasUnsavedChanges = this.checkPanelHasUnsavedChanges();
      var enabledIntegrationCount = this.state.storedState.isFederatedSearchActive ? 1 : 0;
      return (0, _preact.h)(_IntegrationSetup.default, {
        headerTitle: "Skilljar",
        appLogoName: "skilljar-l",
        appContainerBackgroundColor: "#1694D1",
        dismissMessage: this.dismissMessage,
        messageType: messageType,
        message: message,
        installButton: isInstalled ? (0, _preact.h)(_PanelItems.InstallAndUninstallButtons, {
          onClickUninstallButton: function onClickUninstallButton() {
            return _this2.onClickUninstallButton();
          }
        }) : (0, _preact.h)(_Button.default, {
          size: "medium",
          variant: "brand",
          title: "Install now",
          className: "installation__button_cta",
          onClick: function onClick() {
            return _this2.setActiveTab(1);
          }
        }),
        description: (0, _preact.h)(OverviewDescriptionText, null),
        tabTitles: ['Integration', 'Installation'],
        activeTab: activeTab,
        onClickTab: function onClickTab(selectedTab) {
          return _this2.setActiveTab(selectedTab);
        },
        tabContents: [(0, _preact.h)(_Tabs.IntegrationTab, {
          key: "integrationTab",
          activePanel: activePanel,
          isInstalled: isInstalled,
          isFederatedSearchActive: isFederatedSearchActive,
          showActionButtons: showFederatedSearchActionButtons,
          onSave: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
            return _regenerator.default.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    _context4.next = 2;
                    return _this2.saveFederatedSearchSetting();

                  case 2:
                    return _context4.abrupt("return", _context4.sent);

                  case 3:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          })),
          onCancel: function onCancel() {
            return _this2.resetFederatedSearchSetting();
          },
          onSettingChanged: function onSettingChanged() {
            return _this2.onFederatedSearchSettingChanged(!isFederatedSearchActive);
          },
          hasUnsavedChanges: panelHasUnsavedChanges,
          showUnsavedChangesModal: showUnsavedChangesModal,
          displayUnsavedChangedModal: function displayUnsavedChangedModal() {
            return _this2.displayUnsavedChangedModal();
          },
          closeModal: function closeModal() {
            return _this2.closeModal();
          },
          resetChanges: function resetChanges() {
            return _this2.onResetIntegrationTab(1);
          },
          isSavingFederatedSearchSetting: isSavingFederatedSearchSetting,
          onClickPanelCallback: function onClickPanelCallback(selectedPanel) {
            return _this2.setSelectedPanel(selectedPanel);
          },
          storedState: storedState,
          federatedSearchInitialSyncCompleted: federatedSearchInitialSyncCompleted
        }), (0, _preact.h)(_Tabs.InstallationTab, {
          key: "installationTab",
          apiKey: apiKey,
          subdomain: subdomain,
          isInstalled: isInstalled,
          onSave: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
            return _regenerator.default.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    _context5.next = 2;
                    return _this2.onInstall();

                  case 2:
                    return _context5.abrupt("return", _context5.sent);

                  case 3:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5);
          })),
          onCancel: function onCancel() {
            return _this2.onResetInstallationTab(1);
          },
          onApiKeyChangeCallback: function onApiKeyChangeCallback(value) {
            return _this2.setState({
              apiKey: value
            });
          },
          onApiKeyClickCallback: function onApiKeyClickCallback() {
            _this2.removeValidationErrorFromInputField('apiKey');
          },
          onSubdomainChangeCallback: function onSubdomainChangeCallback(value) {
            return _this2.setState({
              subdomain: value
            });
          },
          onSubdomainClickCallback: function onSubdomainClickCallback() {
            return _this2.removeValidationErrorFromInputField('subdomain');
          },
          onClickManage: function onClickManage() {
            return _this2.setActiveTab(0);
          },
          onClickUninstall: function onClickUninstall() {
            return _this2.onClickUninstallButton();
          },
          errorFields: errorFields,
          hasUnsavedChanges: panelHasUnsavedChanges,
          showUnsavedChangesModal: showUnsavedChangesModal,
          displayUnsavedChangedModal: function displayUnsavedChangedModal() {
            return _this2.displayUnsavedChangedModal();
          },
          closeModal: function closeModal() {
            return _this2.closeModal();
          },
          resetChanges: function resetChanges() {
            return _this2.onResetInstallationTab(0);
          },
          isSavingCredentials: isSavingCredentials
        })],
        uninstallModal: (0, _preact.h)(_UninstallModal.default, {
          headerTitle: "Skilljar",
          onUninstall: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
            return _regenerator.default.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    _context6.next = 2;
                    return _this2.onUninstall();

                  case 2:
                    return _context6.abrupt("return", _context6.sent);

                  case 3:
                  case "end":
                    return _context6.stop();
                }
              }
            }, _callee6);
          })),
          showUninstallModal: showUninstallModal,
          closeUninstallModal: function closeUninstallModal() {
            return _this2.closeUninstallModal();
          },
          enabledIntegrationCount: enabledIntegrationCount
        })
      });
    }
  }]);
  return SkilljarIntegration;
}(_interfaces.Integration);

var OverviewDescriptionText = function OverviewDescriptionText() {
  return (0, _preact.h)("div", null, "Skilljar is a Customer Training Platform, providing the tools and foundation for successful customer and partner engagement and enablement.", (0, _preact.h)("div", {
    className: "description-details"
  }, "With Gainsight ", _constants.PLATFORM_BRAND_NAME_POSSESSIVE_FORM, " Skilljar integration, you can easily set up a Skilljar federated search. Your customers can seamlessly search for Skilljar courses through your ", _constants.PLATFORM_BRAND_NAME, "."));
};

var _default = SkilljarIntegration;
exports.default = _default;